export function getLevelName(level) {
  return level.floor_number !== undefined ? `Floor ${level.floor_number}` : level.display_name
}

export function findEntranceLevel(levels) {
  let relevantLevels = levels.filter((level) => level.is_entrance)

  if (relevantLevels.length === 0) {
    relevantLevels = levels
  }

  return relevantLevels.reduce(
    (minLevel, currentLevel) => (currentLevel.floor_number < minLevel.floor_number ? currentLevel : minLevel),
    relevantLevels[0],
  )
}
